<main class="main">
  <header class="h-12 bg-primary text-primary-contrast">
    <div class="header max-content-width mx-auto flex items-center justify-between">
      <a routerLink="/" class="reset cursor-pointer">
        Weight Tracker
      </a>
      <span class="flex items-center gap-4">
        <a routerLink="/weight-entries" class="reset cursor-pointer">
          Einträge
        </a>
        <a routerLink="/rabbits" class="reset cursor-pointer">
          Kaninchen
        </a>
      </span>
    </div>
  </header>
  <div class="content max-content-width mx-auto">
    <p-toast />
    <router-outlet></router-outlet>
  </div>
</main>
